import { PanelDTO } from "./Panel.DTO";
import { EstadoEnum, obtenerIdEstado, TipoEstudioEnum, obtenerIdTipoEstudio } from "@shared/enums";
import { Nilable } from "@shared/utils";

export interface IEstudio {
    id: number;
    lastRun: string;
    type: string;
    brand: string;
    lastAnswers: number;
    status: string;
    link?: Nilable<string>;
}

export class EstudioDTO {
    public id = 0;
    public ultimaCorrida: Date;
    public tipo: TipoEstudioEnum;
    public marca: string;
    public ultimasRespuestas = 0;
    public estado: EstadoEnum;
    public archivos: string[] = [];
    public archivosDashboard: string[] = [];
    public panel: PanelDTO = new PanelDTO();
    public esDemo = false;


    constructor(json: Nilable<Partial<IEstudio>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IEstudio>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.lastRun != null) {
            this.ultimaCorrida = new Date(json.lastRun);
        }
        if (json.type != null) {
            this.tipo = TipoEstudioEnum[json.type.toUpperCase()];
        }
        if (json.brand != null) {
            this.marca = json.brand;
        }
        if (json.lastAnswers != null) {
            this.ultimasRespuestas = json.lastAnswers;
        }
        if (json.status != null) {
            this.estado = EstadoEnum[json.status];
        }
    }

    public obtenerJSON(): IEstudio {
        return {
            id: this.id,
            lastRun: this.ultimaCorrida.toISOString(),
            type: obtenerIdTipoEstudio(this.tipo),
            brand: this.marca,
            lastAnswers: this.ultimasRespuestas,
            status: obtenerIdEstado(this.estado)
        };
    }
}
